<template>
  <el-dialog
    title="提示"
    :visible.sync="formVisible1"
    :close-on-click-modal="false"
    width="600px"
  >
    <div class="cancel-dialog-content">
      <!-- 警告提示 -->
      <div class="warning-message">
        <i class="el-icon-warning warning-icon"></i>
        <span>是否确认取消会议</span>
      </div>

      <!-- 表单 -->
      <el-form
        ref="dataForm"
        :rules="formRules"
        :model="form"
        label-position="right"
        size="small"
        label-width="110px"
      >
        <el-form-item
          prop="reason2"
          label="取消原因:"
          class="cancel-reason-item"
        >
          <el-select
            v-model="form.reason2"
            placeholder="请选择取消原因"
            class="reason-select"
          >
            <el-option
              v-for="(item, index) in reundOptions"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          <!-- 提示信息 -->
          <div class="info-message">
            取消会议,所有已报名记录将被一起取消。注意,报名费用将不会退款。
          </div>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible1 = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import meetingApi from "@/api/meeting/meeting";
import meetingSignUpApi from "@/api/meeting/meetingSignUp";
import sysDataconstantApi from "@/api/config/sysDataconstant";
function initFormBean() {
  const formBean = {
    reason2: null
  };
  return formBean;
}

export default {
  data() {
    return {
      form: initFormBean(),
      formVisible1: false,
      formRules: {
        reason2: [
          { required: true, message: "请选择取消原因", trigger: "change" }
        ]
      },
      reasonOptions: [],
      type: 0, //1  表示从会议报名过来取消   0 取消会议
      rowId: 0,
      reundOptions: []
    };
  },
  created() {},
  methods: {
    getDataconstant() {
      sysDataconstantApi
        .fetchBatchCode({ code: "meetingCancelReasons" })
        .then(data => {
          this.formVisible1 = true;
          const { list } = data.data;
          const find1 = list.find(itt => itt.code === "meetingCancelReasons");
          if (find1) {
            this.reundOptions = find1.content.split(",");
          }
          this.$nextTick(() => {
            this.$refs["dataForm"].clearValidate();
          });
        });
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          const { reason2 } = this.form;
          const params = {
            id: this.rowId,
            cancelReason: reason2
          };
          if (this.type) {
            meetingSignUpApi.cancelMeeting(params).then(() => {
              this.postCallback();
            });
          } else {
            meetingApi.cancelMeeting(params).then(() => {
              this.postCallback();
            });
          }
        }
      });
    },
    postCallback() {
      this.$message.success("操作成功");
      this.formVisible1 = false;
      this.$emit("created");
    },
    handleCancel(row, type) {
      this.$set(this.form, "reason2", "");
      this.rowId = row.id;
      this.type = type;
      this.getDataconstant();
    }
  }
};
</script>
<style lang="scss" scoped>
.cancel-dialog-content {
  padding: 10px 0;
}

.warning-message {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .warning-icon {
    font-size: 20px;
    color: #e6a23c;
    margin-right: 10px;
  }

  span {
    font-size: 14px;
    color: #303133;
  }
}

.cancel-reason-item {
  margin-bottom: 15px;

  .reason-select {
    flex: 1;
  }
}

.info-message {
  margin-top: 10px;
  font-size: 12px;
  color: #8f8e8e;
  line-height: 1.5;
}
</style>
